/*!

=========================================================
* Paper Kit React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState, useRef } from "react";

// reactstrap components
// import { Container, Row, Col } from "reactstrap";

// core components

function SectionBB() {
  const [loaded, setLoaded] = useState(false);
  const [loadError, setLoadError] = useState(false);
  const iframeRef = useRef(null);

  const handleIframeLoad = () => {
    try {
      // พยายามเข้า contentDocument เพื่อตรวจสอบ CORS
      if (iframeRef.current?.contentDocument) {
        setLoaded(true);
      } else {
        // contentDocument === null = iframe ถูกบล็อก CORS
        setLoadError(true);
      }
    } catch (err) {
      // Exception = iframe ถูกบล็อก CORS
      setLoadError(true);
    }
  };

  useEffect(() => {
    if (loaded || loadError) {
      return;
    }
    const timeout = setTimeout(() => {
      if (!loaded) {
        setLoadError(true);
      }
    }, 9000);
    return () => clearTimeout(timeout);
  }, [loaded, loadError]);

  return (
    <div className="App">
      {loadError ? (
        <div className="text-center p-5" style={{ background: "#f8f9fa", borderRadius: "1rem", border: "1px solid #dee2e6" }}>
          <h4 className="mb-3 text-primary">⚠️ ไม่สามารถโหลดเนื้อหาได้</h4>
          <p className="mb-2">
            เนื้อหาปฏิทินงบประมาณจากเว็บไซต์สำนักงบประมาณไม่สามารถแสดงภายในหน้านี้ได้
          </p>
          <p className="mb-4 text-muted small">
            (เนื่องจากเว็บไซต์ต้นทางมีการป้องกันการฝัง iframe เพื่อความปลอดภัย)
          </p>
          <a 
            href="https://www.bb.go.th/embed/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="btn btn-sm btn-primary"
          >
            ดูปฏิทินงบประมาณโดยตรง →
          </a>
        </div>
      ) : (
        <iframe
          ref={iframeRef}
          width="100%"
          height="800"
          src="https://www.bb.go.th/embed"
          frameBorder="0"
          title="https://www.bb.go.th"
          onLoad={handleIframeLoad}
          onError={() => setLoadError(true)}
          style={{ minHeight: "400px" }}
        ></iframe>
      )}
      <p className="text-center mt-3">
        เครดิตปฏิทินงบประมาณรายจ่ายประจำปี : เว็บไซต์สำนักงบประมาณ
        https://www.bb.go.th
      </p>
    </div>
  );
}

export default SectionBB;
